import { forwardRef, type InputHTMLAttributes, type SelectHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/utils";

const BASE =
  "w-full rounded-[8px] border border-line bg-surface px-3 text-ink " +
  "placeholder:text-muted transition-colors duration-150 ease-out " +
  "focus:border-primary focus:outline-none focus:ring-4 focus:ring-[var(--focus-ring)]";

/** Le label est toujours présent — jamais de champ identifié par le seul placeholder (§10). */
export function Field({ label, hint, error, children }: {
  label: string; hint?: string; error?: string; children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="eyebrow mb-1.5 block">{label}</span>
      {children}
      {hint && !error ? <span className="mt-1 block text-[13px] text-muted">{hint}</span> : null}
      {error ? <span className="mt-1 block text-[13px] text-crit">{error}</span> : null}
    </label>
  );
}

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      style={{ height: "var(--field-h)" }}
      className={cn(BASE, invalid && "border-crit", className)}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      style={{ height: "var(--field-h)" }}
      className={cn(BASE, "cursor-pointer pr-8", className)}
      {...props}
    />
  ),
);
Select.displayName = "Select";
